import React from 'react';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import MedicationIcon from '@mui/icons-material/Medication';
import MoodIcon from '@mui/icons-material/Mood';
import TaskIcon from '@mui/icons-material/Task';
import EventIcon from '@mui/icons-material/Event';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { SvgIconProps } from '@mui/material';

// Maps icon name from backend (eventType.icon) to MUI icon component
const iconByName: Record<string, React.ElementType> = {
  restaurant: RestaurantIcon,
  fitness_center: FitnessCenterIcon,
  medication: MedicationIcon,
  mood: MoodIcon,
  task: TaskIcon,
  event: EventIcon,
  water_drop: WaterDropIcon,
  // backend sends "consultation" for appointment — map to EventIcon
  consultation: EventIcon,
};

// Fallback map by event type code (when icon field is null)
const iconByCode: Record<string, React.ElementType> = {
  food: RestaurantIcon,
  workout: FitnessCenterIcon,
  medication: MedicationIcon,
  feeling: MoodIcon,
  task: TaskIcon,
  appointment: EventIcon,
  fluid: WaterDropIcon,
};

interface EventTypeIconProps extends Omit<SvgIconProps, 'color'> {
  code: string;
  icon?: string | null;
  accentColor?: string | null;
  size?: number;
}

export const EventTypeIcon: React.FC<EventTypeIconProps> = ({
  code,
  icon,
  accentColor,
  size = 20,
  sx,
  ...rest
}) => {
  const IconComponent =
    (icon ? iconByName[icon] : null) ?? iconByCode[code] ?? CalendarTodayIcon;

  return (
    <IconComponent
      sx={{ fontSize: size, color: accentColor || 'text.secondary', ...sx }}
      {...rest}
    />
  );
};
